<template>
  <base-dialog
    :title="'room.param.windows.title' | i18n"
    :subtitle="'room.param.windows.subtitle' | i18n"
    :description="'room.param.windows.description' | i18n">

    <div class="container-fluid" style="padding: 0;">
      <div class="row">
        <div class="col-4">
          <img src="../../assets/param/room_windows.png" />
        </div>

        <div class="col-8">
          <label>Pieniä ikkunoita kpl</label>
          <select v-model="numOfSmallWindows" class="form-control">
            <option v-for="n in 6" :value="n-1">{{ n-1 }}</option>
          </select>


          <label>Isoja ikkunoita kpl</label>
          <select v-model="numOfLargeWindows" class="form-control">
            <option v-for="n in 6" :value="n-1">{{ n-1 }}</option>
          </select>
        </div>
      </div>
    </div>
  </base-dialog>
</template>


<script>
  import BaseDialog from "./BaseDialog"

  export default {
    computed: {
      numOfSmallWindows: {
        get() {
          return this.$store.state.roomParams.numOfSmallWindows
        },
        set(numOfSmallWindows) {
          this.$store.commit('roomParams/SET_NUM_OF_SMALL_WINDOWS', numOfSmallWindows)
        }
      },
      numOfLargeWindows: {
        get() {
          return this.$store.state.roomParams.numOfLargeWindows
        },
        set(numOfLargeWindows) {
          this.$store.commit('roomParams/SET_NUM_OF_LARGE_WINDOWS', numOfLargeWindows)
        }
      }
    },

    created() {
      if(this.numOfSmallWindows == null) {
        this.numOfSmallWindows = 0
      }
      if(this.numOfLargeWindows == null) {
        this.numOfLargeWindows = 0
      }
    },

    components: {
      BaseDialog
    }
  }
</script>

<style scoped>
  img {
    max-width: 100%;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/RoomWindowsDialog.vue